import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "", componentStack: "" };
  }

  static getDerivedStateFromError(err) {
    return { hasError: true, message: err?.message || String(err) };
  }

  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error("APP CRASH:", err);
    // eslint-disable-next-line no-console
    console.error("Component stack:", info?.componentStack);

    this.setState({ componentStack: info?.componentStack || "" });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{ minHeight: "100vh", background: "#0b0f14", color: "#fff", padding: 20 }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <h1 style={{ fontSize: 18, fontWeight: 800, marginBottom: 10 }}>
            ⚠️ React впав (інакше був “білий екран”)
          </h1>

          <div style={{ opacity: 0.9, marginBottom: 12 }}>
            {this.state.message}
          </div>

          <pre
            style={{
              whiteSpace: "pre-wrap",
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 14,
              padding: 14,
              fontSize: 12,
              overflow: "auto",
            }}
          >
            {this.state.componentStack || "(componentStack порожній)"}
          </pre>

          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 12,
              borderRadius: 999,
              padding: "10px 14px",
              background: "#38bdf8",
              color: "#001018",
              fontWeight: 900,
              border: "none",
              cursor: "pointer",
            }}
          >
            Перезавантажити
          </button>
        </div>
      </div>
    );
  }
}
